<template>
  <div ref="reactRoot"></div>
</template>

<script>
import React from 'react'
import { createRoot } from 'react-dom/client'
import { mapGetters } from 'vuex'
import {setVuexStore} from '../react-component/reactStore/vuexBridge'

export default {
  name: 'ReactWrapper',
  props: {
    component: { type: Function, required: true }, // React component
    propsData: { type: Object, default: () => ({}) }
  },
  data () {
    return {
      root: null
    }
  },
  computed: {
    ...mapGetters(['isExclusive', 'user']),

    // build default props dynamically
    defaultProps () {
      return {
        isExclusive: this.isExclusive,
        user: this.user,
        isDesktop: this.$parent?.isDesktop || false
      }
    }
  },
  mounted () {
    setVuexStore(this.$store)
    this.initializeReact()
  },
  beforeDestroy () {
    if (this.root) {
      this.root.unmount()
    }
  },
  methods: {
    initializeReact () {
      if (!this.root) {
        this.root = createRoot(this.$refs.reactRoot)
      }
      this.renderReact()
    },
    renderReact () {
      if (this.root) {
        const props = { ...this.defaultProps, ...this.propsData }
        this.root.render(
          React.createElement(this.component, props)
        )
      }
    }
  },
  watch: {
    propsData: {
      handler () {
        this.renderReact()
      },
      deep: true
    },
    // also re-render if Vuex values change
    isExclusive () {
      this.renderReact()
    },
    user () {
      this.renderReact()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReactWrapper.vue?bfcea242